"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")); // Constructs a request from the provided body and authentication information and returns the result.


function request(_x, _x2) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(endpoint, onGetAccessToken) {
    var method,
        body,
        accessToken,
        credentials,
        headers,
        requestParams,
        response,
        myresponse,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'GET';
            body = _args.length > 3 ? _args[3] : undefined;
            accessToken = onGetAccessToken();
            credentials = 'same-origin';
            headers = new Headers({
              Authorization: "Bearer ".concat(accessToken)
            });

            if (method !== 'GET') {
              headers.append('Content-Type', 'application/json');
            }

            requestParams = {
              credentials: credentials,
              headers: headers,
              method: method,
              body: body
            };
            _context.next = 9;
            return fetch(endpoint, requestParams);

          case 9:
            response = _context.sent;
            _context.t0 = response.status;
            _context.next = _context.t0 === 200 ? 13 : 17;
            break;

          case 13:
            _context.next = 15;
            return response.json();

          case 15:
            myresponse = _context.sent;
            return _context.abrupt("return", myresponse);

          case 17:
            _context.prev = 17;
            _context.next = 20;
            return response.json();

          case 20:
            throw _context.sent;

          case 23:
            _context.prev = 23;
            _context.t1 = _context["catch"](17);

          case 25:
            return _context.abrupt("return", null);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[17, 23]]);
  }));
  return _request.apply(this, arguments);
}

var _default = request;
exports.default = _default;